<div class="about-container">
  <div class="sub-container">
    <div class="about-img">
      <img width="80%" src="./assets/About.png"  alt=""/>
    </div>
  </div>
  <div class="sub-container">
    <div class="text-block">
      About Oracle Offering DFTE Portal
    </div>
    <div class="desc-block">
      Digital FTEs are digital personas that are constructed to augment human workers in our delivery lifecycle to help
      drive delivery standardization. We believe that our investment in this program will help us create our workforce
      for the future – A seamless blend of human and digital workers that complements and enhances each other’s
      strengths and abilities.
      <br /><br />
    </div>
    <div class="back-btn-div">
      <button mat-button class="back-btn" onclick="javascript:history.back()">Back</button>
    </div>
  </div>
</div>
<div class="footer">
  <a class="footer-link" target="_blank" rel="noopener"
    href="https://global.deloitteresources.com/aboutglbl/goffice/privacy/pages/personnel-privacy-notice.aspx">Personnel
    Privacy Notice</a>
</div>
